import {ActionContext} from "vuex";
import ListModule from "../list-module";
import ListState from "../list-state";
import Ajax from "../../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import OfferDateSlot from "../../entities/booking/offerDateSlot";

interface OfferDateSlotState extends ListState<OfferDateSlot> {
    fristDate: OfferDateSlot;
    editOfferDateSlot: OfferDateSlot;
}

class OfferDateSlotModule extends ListModule<OfferDateSlotState, any, OfferDateSlot> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<OfferDateSlot>(),
        loading: false,
        editOfferDateSlot: new OfferDateSlot(),
    };
    actions = {
        async getAll(context: ActionContext<OfferDateSlotState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get("/api/services/app/OfferDateSlot/GetAll", {
                params: payload.data,
            });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<OfferDateSlot>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<OfferDateSlotState, any>, payload: any) {
            return Ajax.post("/api/services/app/OfferDateSlot/Create", payload.data);
        },
        async createWithImages(
            context: ActionContext<OfferDateSlotState, any>,
            payload: any
        ) {
            await Ajax.post(
                "/api/services/app/OfferDateSlot/CreateWithImages",
                payload.data
            );
        },
        async update(context: ActionContext<OfferDateSlotState, any>, payload: any) {
            await Ajax.put("/api/services/app/OfferDateSlot/Update", payload.data);
        },
        async updateWithImages(
            context: ActionContext<OfferDateSlotState, any>,
            payload: any
        ) {
            await Ajax.put("/api/services/app/OfferDateSlot/UpdateWithImages", payload.data);
        },
        async delete(context: ActionContext<OfferDateSlotState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.delete(
                "/api/services/app/OfferDateSlot/Delete?Id=" + payload.data.id
            );
            context.state.loading = false;
        },
        async get(context: ActionContext<OfferDateSlotState, any>, payload: any) {
            let reponse = await Ajax.get(
                "/api/services/app/OfferDateSlot/Get?Id=" + payload.id
            );
            return reponse.data.result as OfferDateSlot;
        },
    };
    mutations = {
        setCurrentPage(state: OfferDateSlotState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: OfferDateSlotState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: OfferDateSlotState, offerDateSlot: OfferDateSlot) {
            state.editOfferDateSlot = offerDateSlot;
        },
        changeLoading(state: OfferDateSlotState, pass: boolean) {
            state.loading = pass;
        },
    };
}

const offerDateSlotModule = new OfferDateSlotModule();
export default offerDateSlotModule;
